module.exports = __webpack_public_path__ + "static/img/product_two.98acae6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_two.png
// module id = OrUr
// module chunks = 1